import { memo, ReactElement } from 'react'

import { Popconfirm } from 'antd'
import isEqual from 'lodash/isEqual'
import { useSelector } from 'react-redux'

import { HomeDashboardIcon } from 'components/Icons'
import { UNDEFINED_VALUE } from 'const/formatting'
import { setHomeDashboardId } from 'features/App/appService'
import { isUnset } from 'helpers/utilities'
import { selectDomainValue as selectUiDomainValue } from 'selectors/ui'
import { RootReduxState } from 'types'

interface SetAsHomeFieldProps {
    value: string
}

const SetAsHomeField = ({ value }: SetAsHomeFieldProps): ReactElement => {
    const homeDashboardId = useSelector((state: RootReduxState) =>
        selectUiDomainValue(state, ['app', 'homeDashboardId'])
    )

    const isHomeDashboard = value === homeDashboardId

    if (isUnset(value)) {
        return <span>{UNDEFINED_VALUE}</span>
    }

    const onConfirm = (): void => {
        setHomeDashboardId(isHomeDashboard ? null : value).catch(() => {})
    }

    const confirmText = isHomeDashboard
        ? 'Do you want to stop using this as your Home Dashboard?'
        : 'Do you want to set this as your Home Dashboard?'

    return (
        <Popconfirm title={confirmText} onConfirm={onConfirm}>
            <HomeDashboardIcon
                active={isHomeDashboard}
                tooltipPlacement="right"
            />
        </Popconfirm>
    )
}

export default memo(SetAsHomeField, isEqual) as typeof SetAsHomeField
